import BaseModal from 'components/atoms/base-modal';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';
import EmergencyAlertIcon from 'assets/img/emergency-alert.svg?react';

import s from './styles.module.scss';

import type { IEmergencyModalProps } from './types';
import type { FC } from 'react';

const EmergencyModal: FC<IEmergencyModalProps> = (props) => {
  const { openEmergencyModal, onCancel, onSave } = props;
  const { t } = useTranslation();

  const title = (
    <div className={s['emergency-title']}>
      <EmergencyAlertIcon width={32} height={32} />
      <h4>{t('rpmAlertAssessment.emergencyModalTitle')}</h4>
    </div>
  );

  return (
    <BaseModal
      open={openEmergencyModal}
      width="552px"
      title={title}
      zIndex={1051}
      smallBodyPaddingWithFooter
      onCancel={onCancel}
      withFooter={[
        <BaseButton
          dataCy="cancel-button"
          key="cancel"
          type="secondary"
          label={t('controls.no')}
          onClick={onCancel}
        />,
        <BaseButton
          dataCy="save-button"
          key="save"
          type="primary"
          label={t('controls.yes')}
          onClick={onSave}
        />,
      ]}
    >
      <div className={s['emergency-body']}>
        <p>{t('rpmAlertAssessment.emergencyBody')}</p>
        <p className={s.red}>{t('rpmAlertAssessment.emergencyBodyQuestion')}</p>
      </div>
    </BaseModal>
  );
};

export default EmergencyModal;
